import { useIntercomContext } from '@/contexts/intercom-context';

// Common Intercom event tracking
export const trackIntercomEvent = (eventName: string, metadata?: any) => {
  // This will be used in components that have access to the Intercom context
  return { eventName, metadata };
};

// Predefined event names for consistency
export const INTERCOM_EVENTS = {
  // User actions
  USER_LOGIN: 'user_login',
  USER_LOGOUT: 'user_logout',
  USER_REGISTER: 'user_register',

  // Feature usage
  FEATURE_ACCESSED: 'feature_accessed',
  SIMULATION_STARTED: 'simulation_started',
  SIMULATION_COMPLETED: 'simulation_completed',
  FEEDBACK_SUBMITTED: 'feedback_submitted',

  // Page views
  PAGE_VIEWED: 'page_viewed',

  // Support
  HELP_REQUESTED: 'help_requested',
  SUPPORT_CONTACTED: 'support_contacted'
} as const;

// Helper hook for common Intercom operations
export function useIntercomHelpers() {
  const intercom = useIntercomContext();

  const showHelp = () => {
    intercom.showMessages();
  };

  const showSupport = () => {
    intercom.showNewMessage('I need help with my account');
  };

  const trackFeatureUsage = (featureName: string, additionalData?: any) => {
    intercom.trackEvent(INTERCOM_EVENTS.FEATURE_ACCESSED, {
      feature: featureName,
      ...additionalData
    });
  };

  const trackSimulationEvent = (eventType: 'started' | 'completed', simulationId?: string) => {
    const eventName =
      eventType === 'started' ? INTERCOM_EVENTS.SIMULATION_STARTED : INTERCOM_EVENTS.SIMULATION_COMPLETED;

    intercom.trackEvent(eventName, {
      simulationId,
      timestamp: new Date().toISOString()
    });
  };

  return {
    showHelp,
    showSupport,
    trackFeatureUsage,
    trackSimulationEvent,
    ...intercom
  };
}
